"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharePagePopoverComponent = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var ShareResourceComponent_1 = require("../../../../Common/ShareResourceComponent/ShareResourceComponent");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ResourceTypes_1 = require("@CommonFrontendBackend/Resources/ResourceTypes");
var SharePageViewStore_1 = require("Common/ShareResourceComponent/ViewStore/SharePageViewStore");
var CommonNavigationBarPopover_1 = require("Project/TopNavigationBar/DefaultNavigationButtons/PopoverComponents/CommonNavigationBarPopover");
var SharePagePopoverComponent = (function (_super) {
    __extends(SharePagePopoverComponent, _super);
    function SharePagePopoverComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.sharePageViewStore = new SharePageViewStore_1.SharePageViewStore(_this.props.rootDataStore, _this.props.projectStore);
        return _this;
    }
    SharePagePopoverComponent.prototype.render = function () {
        var _a = this.props, projectAction = _a.action, shouldDisableButtonAccess = _a.shouldDisableButtonAccess, projectStore = _a.projectStore, rootDataStore = _a.rootDataStore, telemetry = _a.telemetry, inviteNewUserModal = _a.inviteNewUserModal;
        var disabled = projectAction.disabled;
        var shareButtonDisabled = disabled || shouldDisableButtonAccess;
        var disabledReason = disabled ? projectAction.disabledReason : null;
        var tooltipSize = shareButtonDisabled ? kaleidoscope_1.TooltipSize.Large : kaleidoscope_1.TooltipSize.Small;
        return (react_1.default.createElement(CommonNavigationBarPopover_1.CommonNavigationBarPopover, { action: projectAction, ignoreElements: [".share-resource", ".share-with-team", ".modal-container"], childClassname: "share-resource", isButtonDisabled: shareButtonDisabled, buttonDisabledReason: disabledReason, tooltipSize: tooltipSize },
            react_1.default.createElement(ShareResourceComponent_1.ShareResourceComponent, { inviteNewUserModal: inviteNewUserModal, resourceId: projectStore._id, resourceViewStore: this.sharePageViewStore, userDataStore: rootDataStore.userDataStore, telemetry: telemetry, userInvitePermission: rootDataStore.getAccountDataStore().getUserInvitePermission(), modal: this.props.modal, resourceType: ResourceTypes_1.DashboardResourceType.Page, ownerUserId: projectStore.user, adminsHavePrivilege: true, projectStore: this.props.projectStore })));
    };
    SharePagePopoverComponent = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SharePagePopoverComponent);
    return SharePagePopoverComponent;
}(react_1.default.Component));
exports.SharePagePopoverComponent = SharePagePopoverComponent;
